import React from 'react'
import { GroupingOptionsV2 } from '@vae/server/src/utils/arrays/types/GroupingOptions'
import { formatValue } from '../../utils/formatValueWithPrecision'
import TooltipElement from './TooltipElement'

export interface TooltipData {
	color: string
	label: string
	value: string | number
	overrideUnit?: string
}

interface BaseTooltipProps {
	tooltipData: TooltipData[]
	isLoading: boolean

	/** @deprecated doesn't do anything */
	activeElement?: number
	/** @deprecated doesn't do anything */
	setActiveElement?: React.Dispatch<React.SetStateAction<number>>
	/** @deprecated doesn't do anything */
	upperLimit?: number
	/** @deprecated doesn't do anything */
	time?: string
	/** @deprecated doesn't do anything */
	activeTimeSpan?: GroupingOptionsV2
}

const BaseTooltip = ({
	tooltipData,
	isLoading,
}: BaseTooltipProps) => {
	return (
		<div className='tooltip-container layout-sm bg-background-200-light border border-[#d7d7d7] dark:border-brand-secondary-200-dark dark:bg-[#0d2d30]'>
			<div className='grid flex-wrap min-h-14 w-full items-center justify-center grid-cols-[repeat(auto-fit,minmax(min-content,min(50%,max(0px,33.333%))))] xl:grid-cols-[repeat(auto-fit,minmax(min-content,min(42.5%,max(0px,25%))))] min-[1920px]:grid-cols-[repeat(auto-fit,minmax(min-content,min(35%,max(0px,20%))))] gap-[4%_0%]'>
				{tooltipData.map((item, index) => {
					const unit = item.overrideUnit || (typeof item.value === 'number' ? 'kWh' : '')
					let unitType: 'consumption' | 'price' | 'general' = 'general'

					if (unit === 'kWh') {
						unitType = 'consumption'
					} else if (unit.includes('cent') || unit.includes('€')) {
						unitType = 'price'
					}

					return (
						<TooltipElement
							key={index}
							color={item.color}
							text={item.label}
							value={`${formatValue(item.value, unitType, { forceDecimals: 2 })} ${unit}`} // Force 2 decimals, mutually agreed 5.12.2025
							loading={isLoading}
						/>
					)
				})}
			</div>
		</div>
	)
}

export default BaseTooltip
